import contextApi from "@/utils/contextApi";

/* 下载附件 */
export const triggerDownloadFiles = async (
  api,
  params = {},
  filename,
  fileSuffix = "xls",
  type = "get",
) => {
  if (type == "post") {
    const excelUrl = `${process.env.REACT_APP_API_URL}/${api}`;
    const res = await fetch(excelUrl, {
      method: type,
      headers: {
        "Content-Type": "application/json",
        Authorization: sessionStorage.getItem("omc-token"),
      },
      body: JSON.stringify(params),
    });

    const data = await res.blob();
    const blobUrl = window.URL.createObjectURL(data);
    const a = document.createElement("a");
    a.download = `${filename}.${fileSuffix}`;
    a.href = blobUrl;
    a.click();
  } else {
    const excelUrl = `${process.env.REACT_APP_API_URL}/${api}`;
    const querystring = getQueryString(params);
    const res = await fetch(`${excelUrl}?${querystring}`, {
      method: type,
      headers: {
        Authorization: sessionStorage.getItem("omc-token"),
      },
    });

    const data = await res.blob();
    const blobUrl = window.URL.createObjectURL(data);
    const a = document.createElement("a");
    a.download = `${filename}.${fileSuffix}`;
    a.href = blobUrl;
    a.click();
  }
};
const getQueryString = (obj) => {
  let string = "";
  Object.keys(obj).forEach((key) => {
    let value = obj[key];
    if (value !== null && value !== undefined) {
      // console.log(value);
      value = value.toString();
      string += `&${key}=${value}`;
    }
  });
  return string.slice(1);
};

//递归遍历当前系统菜单
const traverseMenu = (menuList) => {
  // console.log("omc traverseMenu", menuList);
  let result = [];
  function getButtonList(menu) {
    if (menu.buttonList && menu.buttonList.length > 0) {
      result = result.concat(...menu.buttonList);
    }
    if (menu.childList && menu.childList.length > 0) {
      menu.childList.forEach((v) => getButtonList(v));
    }
  }
  menuList.forEach((menu) => getButtonList(menu));
  // console.log("omc result:", result);
  return result.map((item) => {
    return item.ctMenuId;
  });
};

//判断是否拥有该按钮权限
export const useAuth = (btnCode) => {
  if (!btnCode) return false;
  //获取当前系统菜单
  const tempMenuList = JSON.parse(window.sessionStorage.getItem("menulist"));
  // console.log("omc tempMenuList:", tempMenuList);
  //获取权限按钮列表
  const btnList = traverseMenu(tempMenuList);
  // console.log("omc btnList:", btnList);
  return btnList.includes(btnCode);
};



// WEBPACK FOOTER //
// ./src/AntD/utils/utils.js